/* jscpd:ignore-start */
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { getStorage } from '@utils/localStorage';
import pageJump from '@projects/Shell/utils/pageJump';
import * as LX from '@utils/lxWrapper';
import * as Ids from '@utils/ids';
import { isUniversalWindowsXP, isInOldApp4 } from '@utils/getEnv';
import cacheMenu from './utils/cacheMenu';
import { IQuerySubMenuItem, IQueryMenuItem, IMenuInfo, MatchedMenuType } from '../../api/define';
import { RootState } from '../../store';
import MenuTag from './MenuTag';
import styles from './MenuSubItem.module.scss';
/* jscpd:ignore-end */

type MenuType = {
    code: string;
    name: string;
};

type MenuSubItemProps = {
    subMenu: IQuerySubMenuItem;
    menuInfo: IMenuInfo;
    leftMenuList: IQueryMenuItem[];
    matchedMenu: MatchedMenuType;
    pageHash: string;
    menuAuth: string;
    setShellHash: (val: string) => void;
};

const { useCallback, useMemo } = React;
/** 左侧导航栏菜单 */
const MenuSubItem: React.FC<MenuSubItemProps> = ({
    subMenu,
    pageHash,
    menuAuth,
    setShellHash,
    matchedMenu,
}) => {
    /** 修改主页面hash */
    const changeHash = useCallback(() => {
        const url = subMenu.url;
        if (url === pageHash) {
            const thisWindow = pageJump.getThisWindow();
            const noJump = getStorage('nojump');
            if (noJump !== 'true') {
                thisWindow.location.reload();
            }
        } else {
            if (['hot', 'new'].includes(subMenu.mask)) {
                cacheMenu(subMenu.subMenuName);
            }
            setShellHash(url);
        }
        LX.reportMC('b_waimai_e_0ylope0g_mc', 'c_waimai_e_fa4ps4ng', {
            acctId: Ids.getAcctId(),
            menuName: subMenu.subMenuName || '',
        });
    }, [subMenu, pageHash]);

    // 订单赔付 Sub.IndexCompensate && 出餐时间 Sub.MealTime 权限控制
    // 返回哪个就展示哪个
    const showMenu = useMemo(() => {
        const hideMenus = ['Sub.IndexCompensate', 'Sub.MealTime'];
        // xp和老壳子，不展示履约新形态的“预订单”
        if (isUniversalWindowsXP || isInOldApp4) {
            hideMenus.push('Sub.WMOrderReserveNewModel');
        }
        const menuAuthArr = menuAuth.split(',');
        if (!hideMenus.includes(subMenu.menuCode) || menuAuthArr.includes(subMenu.subMenuName))
            return true;
        return false;
    }, [menuAuth, subMenu.subMenuName, subMenu.menuCode]);

    return (
        <>
            {showMenu ? (
                <li
                    className={`${styles.subMenuItem} ${
                        matchedMenu.subMenuCode === subMenu.menuCode ? styles.active : ''
                    }`}
                    onClick={changeHash}
                >
                    <span className={styles.txt}>
                        {subMenu.subMenuName}
                        <MenuTag
                            menuName={subMenu.subMenuName}
                            menuCode={subMenu.menuCode}
                            mask={subMenu.mask}
                        />
                    </span>
                </li>
            ) : null}
        </>
    );
};

/* jscpd:ignore-start */
const mapStateToProps = (state: RootState) => {
    return {
        leftMenuList: state.shellLeftMenu.leftMenuList,
        menuInfo: state.shellLeftMenu.menuInfo,
        pageHash: state.mainContent.pageHash,
        matchedMenu: state.shellLeftMenu.matchedMenu,
        menuAuth: state.shellLeftMenu.menuAuth,
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setShellHash: (val: string) => {
        dispatch({ type: 'mainContent/setShellHash', payload: val });
    },
    setMatchedSubMenu: (val: MenuType) => {
        dispatch({ type: 'shellLeftMenu/setMatchedSubMenu', payload: val });
    },
});
/* jscpd:ignore-end */

export default connect(mapStateToProps, mapDispatchToProps)(MenuSubItem);
